import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { valByKeyWithDot } from '../../../../../../helpers/value'
import { TYPE_INFORMATION_PANEL } from '../../../../constant'
import { selectIndicatorById } from '../../store/slice'
import ItemCheckbox from './ItemCheckbox'
import ItemRadio from './ItemRadio'
import ItemSelect from './ItemSelect'

const Items = ({
  items,
  setting,
  setValue,
  isInline,
  isFirstLevel,
  isMapTitleApi,
  style,
  id,
}) => {
  const indicatorById = useSelector(selectIndicatorById)

  return (
    <div
      style={{
        display: isInline ? 'flex' : undefined,
        flexFlow: isInline ? 'row wrap' : undefined,
        paddingLeft: isFirstLevel ? 0 : 21,
        marginTop: isFirstLevel ? 16 : 0,
        ...style,
      }}
    >
      {items.map(
        (
          {
            type,
            title,
            isRequire,
            key,
            value,
            options,
            onChange,
            renderItem,
            children,
            isInline: isInlineChildren,
            isBreakLine,
            style = {},
            isDisableMapTitle = false,
          },
          index,
        ) => {
          const newTitle =
            isMapTitleApi && !isDisableMapTitle
              ? indicatorById[value]?.ratioName || ''
              : title

          let isDisplayChildren = true

          if (type === TYPE_INFORMATION_PANEL.CHECKBOX) {
            const checked = valByKeyWithDot(setting, key, true) || []
            isDisplayChildren = isRequire || checked.includes(value)
          }

          if (type === TYPE_INFORMATION_PANEL.RADIO) {
            const activeValue = valByKeyWithDot(setting, key, true)
            isDisplayChildren = isRequire || activeValue === value
          }

          return (
            <Fragment key={id + '_' + index}>
              <div
                className="mt1"
                style={{
                  paddingRight: isInline && !isBreakLine ? 35 : 0,
                  width: isBreakLine ? '100%' : undefined,
                  ...style,
                }}
              >
                {type === TYPE_INFORMATION_PANEL.NODE ? (
                  renderItem({ setting, key, setValue })
                ) : type === TYPE_INFORMATION_PANEL.CHECKBOX ? (
                  <>
                    <ItemCheckbox
                      title={newTitle}
                      isRequire={isRequire}
                      keySetting={key}
                      setting={setting}
                      value={value}
                      setValue={setValue}
                      isI18n={!isMapTitleApi || isDisableMapTitle}
                    />
                  </>
                ) : type === TYPE_INFORMATION_PANEL.SELECT ? (
                  <ItemSelect
                    title={newTitle}
                    options={options}
                    keySetting={key}
                    setting={setting}
                    setValue={setValue}
                    onChange={onChange}
                    isI18n={!isMapTitleApi || isDisableMapTitle}
                  />
                ) : (
                  <ItemRadio
                    title={newTitle}
                    isRequire={isRequire}
                    keySetting={key}
                    setting={setting}
                    value={value}
                    setValue={setValue}
                    isI18n={!isMapTitleApi || isDisableMapTitle}
                  />
                )}
              </div>
              {children && isDisplayChildren && (
                <Items
                  items={children}
                  setting={setting}
                  setValue={setValue}
                  isInline={isInlineChildren}
                  isMapTitleApi={isMapTitleApi}
                />
              )}
            </Fragment>
          )
        },
      )}
    </div>
  )
}

Items.propTypes = {
  items: PropTypes.array.isRequired,
  setting: PropTypes.object,
  setValue: PropTypes.func.isRequired,
  isInline: PropTypes.bool,
  isFirstLevel: PropTypes.bool,
  isMapTitleApi: PropTypes.bool,
  style: PropTypes.object,
}

Items.defaultProps = {
  isInline: false,
  isFirstLevel: false,
  style: {},
}

export default Items
